import {Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';

import { depotRequeteSteps } from '../depot-requete/depot-requete.data';
import { DraftDepotRequeteService } from '../depot-requete/draft-depot-requete.service';
import {DepotRequeteState} from '../depot-requete/depot-requete-state.model';

@Component({
    selector: 'jhi-home',
    templateUrl: './home.component.html',
    styleUrls: ['home.component.scss']
})
export class HomeComponent implements OnInit {

    requete: DepotRequeteState;
    isErrorDraftMessage: boolean;
    isDeletedDraftMessage: boolean;

    constructor(
        private draftDepotRequeteService: DraftDepotRequeteService,
        private router: Router
    ) {}

    ngOnInit() {
        this.draftDepotRequeteService.getMyDraftRequeteSummary().subscribe(draftSummary => {
            if (draftSummary) {
                this.requete = this.draftDepotRequeteService.depotRequeteState;
            }
        });

        this.draftDepotRequeteService.eventDraftDeleted.subscribe(() =>  {
            this.requete = this.draftDepotRequeteService.depotRequeteState;
            this.isErrorDraftMessage = false;
            this.isDeletedDraftMessage = true;
        });
    }
    /**
     * Display a popup to take back a draft if there is one, otherwise go to new requete page
     */
    newRequete() {
        this.draftDepotRequeteService.getMyDraftRequeteSummary().subscribe(draftSummary => {
            if (draftSummary) {
                this.isErrorDraftMessage = true;
            } else {
                this.router.navigate([depotRequeteSteps[0].fullRoute]);
            }
        });
    }

    goToDraftRequete() {
        this.router.navigate(['/depot-requete'], { skipLocationChange: true });
    }

    deleteDraftRequete() {
        this.draftDepotRequeteService.displayDraftModal();
    }

    scroll(id: string) {
        let el = document.getElementById(id);
        el.scrollIntoView();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/home.component.ts